module.exports = __webpack_public_path__ + "img/additional-savings-button.028cdcc5.png";